import styled from "styled-components"

const StyledLayout = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${(props) => props.theme.fontsHeading};
  }
  a,
  p,
  span,
  label,
  button,
  input,
  article,
  aside,
  div,
  blockquote,
  details,
  figcaption,
  figure,
  summary,
  option,
  optgroup,
  select,
  textarea,
  fieldset,
  legend {
    font-family: ${(props) => props.theme.fontsText};
  }
  blockquote {
    border-left: 3px solid ${(props) => props.theme.a_color_gradients.a_dark};
  }
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  padding: 0 6rem;
  @media (max-width: 900px) {
    padding: 0 1rem;
    blockquote {
      border-top: 3px solid ${(props) => props.theme.a_color_gradients.a_dark};
      border-bottom: 3px solid
        ${(props) => props.theme.a_color_gradients.a_dark};
    }
  }
`

export { StyledLayout }
